import * as React from 'react'
import SubscribeFlow1 from '@components/subscribe/SubscribeFlow1'
import SubscribeFlow2 from '@components/subscribe/SubscribeFlow2'
import { withRouter } from 'next/router'

type PropsType = {
  router: { query: { f?: '1' | '2' } }
}
function SubscribePage (props: PropsType): React.ReactNode {
  if (props.router.query.f === '2') return (<SubscribeFlow2/>)
  return <SubscribeFlow1/>
}

export default withRouter(SubscribePage as any) as any
